import { Navigate, Outlet } from 'react-router-dom';
import { getTnCAcceptance } from 'src/shared/redux-state/src';
import { useAppSelector } from '../services/store';
import { AppRoutes } from '../navigation/routes';

const TermsConditionsGuard = () => {
    const tnCAccepted = useAppSelector(getTnCAcceptance);
    return (
        tnCAccepted ? <Navigate to={AppRoutes.HOME} /> : <Outlet />
    )
}

export default TermsConditionsGuard;